import { jsx as e } from "react/jsx-runtime";
import { withManagedProps as c } from "@made-people/managed-props";
import { z as i } from "zod";
import { withZod as p } from "@made-people/react-prop-guard";
import { ProductProvider as m } from "@made-people/grease-product";
import { productCardPropsSchema as d, ProductCard as u } from "@made-people/blueprint-product-card";
import { swiperPropsSchema as f, Swiper as b } from "@made-people/blueprint-swiper";
import { useSearchResultItems as h } from "@made-people/grease-search";
import { SkeletonCard as P } from "@made-people/blueprint-skeleton-card";
const S = f.extend({
  productCardSettings: d.optional(),
  offset: i.number().optional(),
  fallback: i.object({
    enabled: i.boolean().optional(),
    amountOfItems: i.number().optional()
  }).optional()
}), O = c(
  "SwipeableProductList",
  p(
    {
      schema: S,
      defaultProps: {
        fallback: {
          amountOfItems: 12,
          enabled: !0
        }
      }
    },
    (t) => {
      var s;
      const l = t.offset ?? 0, n = h(), r = n == null ? void 0 : n.slice(l);
      return r && r.length === 0 ? null : /* @__PURE__ */ e(b, { ...t, settings: t.settings, children: r ? r.map((o, a) => /* @__PURE__ */ e("div", { children: o.type === "product" ? /* @__PURE__ */ e(
        m,
        {
          product: o.product,
          context: {
            type: "plp",
            listId: "swipeable-product-list",
            listName: "Swipeable Product List",
            position: a + l
          },
          children: /* @__PURE__ */ e(u, { ...t.productCardSettings })
        }
      ) : o.type === "component" ? o.data : null }, `product-${a + l}`)) : Array.from(
        { length: ((s = t.fallback) == null ? void 0 : s.amountOfItems) ?? 12 },
        (o, a) => /* @__PURE__ */ e(P, {}, `skeleton-${a}`)
      ) });
    }
  )
);
export {
  O as SwipeableProductList,
  S as swipeableProductListSchema
};
//# sourceMappingURL=index.es.js.map
